var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PickUpListService } from '../shared/pick-up-list.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReservationDialogComponent } from '../reservation-dialog/reservation-dialog.component';
import { MatDialog } from '@angular/material';
import { CuiBaseComponent } from '@cicero/webui/lib/core/shared/base-component';
import { ReservationService } from '../shared/reservation.service';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { MaterialService } from '../../material/material.service';
var animationDuration = 200;
var PickUpListComponent = /** @class */ (function (_super) {
    __extends(PickUpListComponent, _super);
    function PickUpListComponent(route, router, pickUpList, materialService, dialog, reservationService) {
        var _this = _super.call(this) || this;
        _this.route = route;
        _this.router = router;
        _this.pickUpList = pickUpList;
        _this.materialService = materialService;
        _this.dialog = dialog;
        _this.reservationService = reservationService;
        _this.reservations = new BehaviorSubject([]);
        _this.visibleReservations = [];
        _this.displayedReservations = new BehaviorSubject([]);
        _this.queryDescriptor = new BehaviorSubject('');
        _this.showQueryDescriptor = false;
        _this.reservationStateChange = new Subject();
        _this.sortByReservationDate = new FormControl(false);
        _this.hideHandled = new FormControl(false);
        _this.showDetails = new FormControl(false);
        _this.hasLoaded = false;
        return _this;
    }
    Object.defineProperty(PickUpListComponent.prototype, "isOffline", {
        get: function () {
            return !window.navigator.onLine;
        },
        enumerable: true,
        configurable: true
    });
    PickUpListComponent.prototype.ngOnInit = function () {
        this.pushSubscription(this.startReservationStatePolling(), this.setupReservationFetching(), this.setupReservationSorting(), this.setupReservationFiltering(), this.setupReservationDetails());
    };
    PickUpListComponent.prototype.startReservationStatePolling = function () {
        var _this = this;
        if (environment.disableLongRunningTasks) {
            return Observable.empty().subscribe();
        }
        return Observable.interval(environment.pickUpListPollingInterval)
            .switchMap(function () { return _this.pickUpList.updateReservationStates(_this.reservations.getValue()); })
            .subscribe(function (reservations) { return _this.reservations.next(reservations); });
    };
    PickUpListComponent.prototype.setupReservationFetching = function () {
        var _this = this;
        return this.route.queryParams
            .do(function () { return _this.hasLoaded = false; })
            .switchMap(function (queryParams) { return _this.pickUpList.search(queryParams); })
            .map(function (result) { return Object.assign(result, { reservations: _this.sortReservations(result.reservations) }); })
            .do(function () { return _this.hasLoaded = true; })
            .subscribe(function (result) {
            _this.reservations.next(result.reservations);
            _this.queryDescriptor.next(result.query);
            _this.showQueryDescriptor = true;
            _this.materialService.getCovers(result.reservations.map(function (r) { return r.faustNumber; }))
                .map(function (covers) { return result.reservations.map(function (r) { return Object.assign(r, { cover: covers[r.faustNumber].detail }); }); })
                .subscribe(function (reservations) { return _this.reservations.next(reservations); });
        }, function () { return _this.error = 'Noget gik galt da vi hentede søgeresultaterne.'; });
    };
    PickUpListComponent.prototype.setupReservationSorting = function () {
        var _this = this;
        return this.sortByReservationDate.valueChanges
            .subscribe(function () { return _this.reservations.next(_this.sortReservations(_this.reservations.getValue())); });
    };
    PickUpListComponent.prototype.setupReservationFiltering = function () {
        var _this = this;
        return Observable.merge(this.hideHandled.valueChanges, this.reservationStateChange.filter(function () { return _this.hideHandled.value; }).delay(animationDuration), this.reservations)
            .map(function () { return _this.reservations.getValue(); })
            .map(function (reservations) { return _this.filterReservations(reservations); })
            .subscribe(function (reservations) {
            _this.displayedReservations.next(reservations);
            _this.displayedReservationHeights = _this.getReservationHeights(reservations);
        });
    };
    PickUpListComponent.prototype.setupReservationDetails = function () {
        var _this = this;
        return this.showDetails.valueChanges
            .subscribe(function () { return _this.displayedReservationHeights = _this.getReservationHeights(_this.displayedReservations.getValue()); });
    };
    PickUpListComponent.prototype.getReservationHeights = function (reservations) {
        /**
         NOTICE: The following constants depends on the height of the reservation component.
         This method can predict the painted height of the reservation component based on its data.
         */
        var contentHeight = 186;
        var hrHeight = 2;
        var detailsHeight = 71;
        var materialHeight = 17;
        if (!this.showDetails.value) {
            return contentHeight + hrHeight;
        }
        return reservations.reduce(function (heights, reservation) {
            var height = contentHeight + hrHeight + detailsHeight + materialHeight * reservation.materials.length;
            if (heights.length) {
                height += heights[heights.length - 1];
            }
            heights.push(height);
            return heights;
        }, []);
    };
    PickUpListComponent.prototype.sortReservations = function (reservations) {
        return this.sortByReservationDate.value
            ? this.pickUpList.sortByReservationAge(reservations)
            : this.pickUpList.sort(reservations);
    };
    PickUpListComponent.prototype.filterReservations = function (reservations) {
        if (!this.hideHandled.value) {
            return reservations;
        }
        return reservations.filter(function (reservation) { return !reservation.state; });
    };
    PickUpListComponent.prototype.showDialog = function (reservation) {
        var _this = this;
        var dialog = this.dialog.open(ReservationDialogComponent, {
            data: reservation,
            backdropClass: 'no-overflow-no-padding-backdrop'
        });
        dialog.componentInstance.reservationStateChange.subscribe(function () { return _this.reservationStateChange.next(); });
    };
    PickUpListComponent.prototype.undo = function (reservation) {
        this.reservationService.undo(reservation).subscribe();
        this.reservationStateChange.next();
    };
    PickUpListComponent.prototype.markSkipped = function (reservation) {
        this.reservationService.markSkipped(reservation);
        this.reservationStateChange.next();
    };
    PickUpListComponent.prototype.markFound = function (reservation) {
        this.reservationService.markFound(reservation).subscribe();
        this.reservationStateChange.next();
    };
    PickUpListComponent.prototype.markNotFound = function (reservation) {
        var _this = this;
        this.reservationService.markNotFound(reservation).subscribe(null, function () { return _this.reservationStateChange.next(); });
        this.reservationStateChange.next();
    };
    return PickUpListComponent;
}(CuiBaseComponent));
export { PickUpListComponent };



// WEBPACK FOOTER //
// ./src/app/pick-up-list/pick-up-list/pick-up-list.component.ts.pre-build-optimizer.js